export enum BillingTypeName {
  '01' = 'Factura',
  '03' = 'Boleta',
  '07' = 'Nota de crédito',
  '08' = 'Nota de débito',
  Otro = 'Otro'
}

export enum BillingFileFormat {
  PDF = 'pdf',
  XML = 'xml',
  CDR = 'cdr'
}

export const NoDataTableMessage: {
  readonly title: string;
  readonly description: string;
} = {
  title: 'No se encontraron resultados',
  description: 'Actualmente no tienes ninguna factura.'
};

export const ErrorTableMessage: {
  readonly title: string;
  readonly description: string;
  readonly textButton: string;
} = {
  title: 'No pudimos cargar tus archivos',
  description: 'Las conexiones están tardando más de lo esperado. Intenta actualizar para ver tus documentos.',
  textButton: 'Actualizar pagina'
};

export const DateRangeErrorTableMessage: {
  readonly title: string;
  readonly description: string;
} = {
  title: 'Error',
  description: 'Selecciona un rango de fechas menor o igual a 31 días, por favor.'
}; 